const Content = {
    modal: {
        editTql: {
            title: `Are you sure?`,
            bodyText: `You are about to manually edit the TQL statement, 
                meaning the menus won't update and there will be no validation. 
                Are you sure you want to continue?`
        },
        resetTql: {
            title: 'Are you sure?',
            bodyText: 'Are you sure you want to reset TQL Builder? This will clear all selections.'
        },
        welcomeTql: {
            title: "Welcome to TQL Builder",
            bodyText: "Technopedia Query Language (TQL) is used to make API requests to Technopedia. This tool helps you explore the Technopedia model and construct queries using a simple dropdown interface.",
            bodyText2: "Importantly, this is a beta release, so your feedback is greatly appreciated!"
        },
        tqlExamples: [
            {
                title: "Example 1",
                bodyText: "Find all releases of Internet Explorer",
            },
            {
                title: "Example 2",
                bodyText: "Find all releases of all Graphics and Image Editing software made by Adobe",
            },
            {
                title: "Example 3",
                bodyText: "Find all workstations manufactured by IBM and introduced after 1/30/2015"
            },
        ]
    }
}

export default Content;






// WEBPACK FOOTER //
// ./src/config/Content.js